// @core/api/endpoints/document/deprecate_clause.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DeprecateClauseRequest,
  DocumentClauseResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Deprecate clause
 * Marks a clause DEPRECATED. When supersede_clause_id is provided, the newer clause's supersedes field is set to this clause's entity.
 */
export async function DeprecateClause(
  clause_id: string,
  data: DeprecateClauseRequest,
  options?: RequestOptions
): Promise<DocumentClauseResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/clauses/:clause_id/deprecate`;
  requestPath = requestPath.replace(':clause_id', encodeURIComponent(clause_id));
  const requestOptions = options;
  return client.post<DocumentClauseResponse>(requestPath, data, requestOptions);
}
